<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>人均通关统计</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
          >
            <template scope="scope">
              {{ dateStrTodate(scope.row.date) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="总通关数"
            align="center"
          />
          <el-table-column
            label="1-2"
            align="center"
          >
            <el-table-column
              prop="lv1"
              label="人数"
              align="center"
            />
            <el-table-column
              prop="lv1Avg"
              label="人均通关"
              align="center"
            />
          </el-table-column>
          <el-table-column
            label="2-3"
            align="center"
          >
            <el-table-column
              prop="lv2"
              label="人数"
              align="center"
            />
            <el-table-column
              prop="lv2Avg"
              label="人均通关"
              align="center"
            />
          </el-table-column>
          <el-table-column
            label="3-5"
            align="center"
          >
            <el-table-column
              prop="lv3"
              label="人数"
              align="center"
            />
            <el-table-column
              prop="lv3Avg"
              label="人均通关"
              align="center"
            />
          </el-table-column>
          <el-table-column
            label="5-10"
            align="center"
          >
            <el-table-column
              prop="lv4"
              label="人数"
              align="center"
            />
            <el-table-column
              prop="lv4Avg"
              label="人均通关"
              align="center"
            />
          </el-table-column>
          <el-table-column
            label="10-20"
            align="center"
          >
            <el-table-column
              prop="lv5"
              label="人数"
              align="center"
            />
            <el-table-column
              prop="lv5Avg"
              label="人均通关"
              align="center"
            />
          </el-table-column>
          <el-table-column
            label="20-30"
            align="center"
          >
            <el-table-column
              prop="lv6"
              label="人数"
              align="center"
            />
            <el-table-column
              prop="lv6Avg"
              label="人均通关"
              align="center"
            />
          </el-table-column>
          <el-table-column
            label="30-60"
            align="center"
          >
            <el-table-column
              prop="lv7"
              label="人数"
              align="center"
            />
            <el-table-column
              prop="lv7Avg"
              label="人均通关"
              align="center"
            />
          </el-table-column>
          <el-table-column
            label="60-90"
            align="center"
          >
            <el-table-column
              prop="lv8"
              label="人数"
              align="center"
            />
            <el-table-column
              prop="lv8Avg"
              label="人均通关"
              align="center"
            />
          </el-table-column>
          <el-table-column
            label="90-120"
            align="center"
          >
            <el-table-column
              prop="lv9"
              label="人数"
              align="center"
            />
            <el-table-column
              prop="lv9Avg"
              label="人均通关"
              align="center"
            />
          </el-table-column>
        </el-table>
      </el-card>

      <el-row :gutter="12">
        <upLevelCountAvg ref="countAvg" />
      </el-row>

      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <upLevelAvg ref="dayAvgCount" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <upLevelAvg ref="avg" :typ="2" :title="'人均通关次数'" />
        </el-col>
      </el-row>

    </template>
  </BasicLayout>
</template>

<script>
import { getUserUpLevelCountStat } from '@/api/user/user_info'
import upLevelAvg from '@/views/config/up-level-stat/components/uplevel-level-avg-stat.vue'
import upLevelCountAvg from '@/views/config/up-level-stat/components/uplevel-level-num-stat.vue'
import { getLastDates, dateStrTodate, scientificFormat } from '@/utils'
export default {
  name: 'UpLevelCountStat',
  components: {
    upLevelAvg,
    upLevelCountAvg
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(0)
    }

    this.getTables()
  },
  methods: {
    dateStrTodate,
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      getUserUpLevelCountStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data
          this.$refs.countAvg.refresh(this.tableData)
          this.$refs.dayAvgCount.refresh(this.tableData)
          this.$refs.avg.refresh(this.tableData)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
